import { BaseError } from './base-error';

export class InvalidOperationError extends BaseError {
  public readonly name = 'InvalidOperationError';

  constructor(message: string, context?: Error | any, parentError?: Error) {
    super(message, context, parentError);
  }
}
